import { motion } from "framer-motion";
import { METHOD } from "../../data/site";

const ease = [0.22, 1, 0.36, 1];

const Step = ({ item, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, ease, delay: index * 0.1 }}
    className="group"
    data-testid={`method-step-${item.n}`}
  >
    <div className="relative aspect-[4/3] overflow-hidden rounded-2xl border border-white/10">
      <img
        src={item.image}
        alt={item.title}
        className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0c]/60 to-transparent" />
      <span className="absolute left-4 top-3 font-display text-xs font-light tracking-[0.3em] text-white/70">
        {item.n}
      </span>
    </div>
    <h3 className="mt-5 font-display text-xl font-normal tracking-tight text-white">
      {item.title}
    </h3>
    <p className="mt-2 text-sm leading-relaxed text-white/55">{item.body}</p>
  </motion.div>
);

export const Manifesto = () => (
  <section
    id="method"
    className="relative z-10 mx-auto max-w-6xl px-6 py-20 md:px-10 md:py-24"
    data-testid="method-section"
  >
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease }}
      className="mb-12 max-w-2xl md:mb-16"
    >
      <p className="mb-4 text-xs font-semibold uppercase tracking-[0.35em] text-white/40">
        The Method
      </p>
      <h2 className="font-display text-3xl font-thin leading-tight tracking-tight text-white md:text-4xl">
        Regulation creates clarity.{" "}
        <span className="italic text-white/70">Clarity creates magnetism.</span>
      </h2>
    </motion.div>

    <div className="grid grid-cols-1 gap-10 sm:grid-cols-3 sm:gap-7">
      {METHOD.map((item, i) => (
        <Step key={item.n} item={item} index={i} />
      ))}
    </div>
  </section>
);
